import { sanitize } from '../utils/sanitizeText'
import { getURL, baseInteraction, sendEvent } from './utils'

const SCREEN_NAME = 'visualizar-proposta'

export const TagPushProposal = {
    screenView: (url, cpf, cnpj) => {
        let event = {
            event: 'screen_view',
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: `loja-virtual:${SCREEN_NAME}`,
            screen_type: 'pagina',
            ...baseInteraction(cpf, cnpj)
        }
        sendEvent(event)
    },
    interactionIconButton: (text = 'none', url, cpf, cnpj) => {
        let event = {
            event: 'interaction',
            element_type: 'select:icon:click',
            element_content: `none:${sanitize(text)}:none`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: `loja-virtual:${SCREEN_NAME}`,
            screen_type: 'pagina',
            ...baseInteraction(cpf, cnpj)
        }
        sendEvent(event)
    },
    interactionAddToProposal: (cardName = 'none', url, cpf, cnpj) => {
        let event = {
            event: 'interaction',
            element_type: 'box:button:click',
            element_content: `none:adicionar-ao-carrinho&${sanitize(cardName)}:adicionar-carrinho`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: `loja-virtual:${SCREEN_NAME}`,
            screen_type: 'pagina',
            ...baseInteraction(cpf, cnpj)
        }
        sendEvent(event)
    },
    interactionLink: (text, url, cpf, cnpj) => {
        let event = {
            event: 'interaction',
            element_type: 'select:link:click',
            element_content: `none:${sanitize(text)}:none`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: `loja-virtual:${SCREEN_NAME}`,
            screen_type: 'pagina',
            ...baseInteraction(cpf, cnpj)
        }
        sendEvent(event)
    },
    interactionButton: (text, url, cpf, cnpj) => {
        let event = {
            event: 'interaction',
            element_type: 'box:button:click',
            element_content: `none:${sanitize(text)}:none`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: `loja-virtual:${SCREEN_NAME}`,
            screen_type: 'pagina',
            ...baseInteraction(cpf, cnpj)
        }
        sendEvent(event)
    },
    interactionRemove: (url, cpf, cnpj) => {
        let event = {
            event: 'interaction',
            element_type: 'box:icon:click',
            element_content: `none:none:remover`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: `loja-virtual:${SCREEN_NAME}`,
            screen_type: 'pagina',
            ...baseInteraction(cpf, cnpj)
        }
        sendEvent(event)
    },
    interactionFieldProposal: (field, url, cpf, cnpj) => {
        let event = {
            event: 'interaction',
            element_type: `box:${sanitize(field)}-field:filled`,
            element_content: `none:${SCREEN_NAME}:none`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: `loja-virtual:${SCREEN_NAME}`,
            screen_type: 'pagina',
            ...baseInteraction(cpf, cnpj)
        }
        sendEvent(event)
    },
    screenViewHasProduct: (url, cpf, cnpj) => {
        let event = {
            event: 'screen_view',
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: `loja-virtual:sua-empresa-ja-tem-esse-produto:${SCREEN_NAME}`,
            screen_type: 'pagina',
            ...baseInteraction(cpf, cnpj)
        }
        sendEvent(event)
    },
    screenViewHasOneOfProduct: (url, cpf, cnpj) => {
        let event = {
            event: 'screen_view',
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: `loja-virtual:sua-empresa-ja-tem-um-desses-produtos:${SCREEN_NAME}`,
            screen_type: 'pagina',
            ...baseInteraction(cpf, cnpj)
        }
        sendEvent(event)
    }
}
